interface WelcomeScreenProps {
  onPromptSelect: (text: string) => void;
}

const EXAMPLE_PROMPTS = [
  { emoji: '💡', text: 'What can you help me with?' },
  { emoji: '📝', text: 'Help me write a thank-you note' },
  { emoji: '🌍', text: 'Tell me something interesting about Japan' },
  { emoji: '🍳', text: "What's a quick recipe for dinner tonight?" },
] as const;

export default function WelcomeScreen({ onPromptSelect }: WelcomeScreenProps) {
  return (
    <div
      className="flex h-full flex-col items-center justify-center px-4 py-8"
      style={{ animation: 'welcomeFadeIn 0.35s ease-out both' }}
    >
      <div className="w-full max-w-sm text-center">
        <h1 className="mb-1.5 text-2xl font-semibold text-foreground">Hey there! 👋</h1>
        <p className="mb-6 text-sm text-muted-foreground">
          I'm your AI assistant. Here are some things you can ask me:
        </p>

        <div className="grid grid-cols-2 gap-3">
          {EXAMPLE_PROMPTS.map(({ emoji, text }) => (
            <button
              key={text}
              type="button"
              onClick={() => onPromptSelect(text)}
              className="flex min-h-[72px] flex-col items-start gap-2 rounded-2xl border border-border bg-card px-4 py-3 text-left text-sm transition-all hover:border-ring hover:bg-secondary active:scale-[0.97]"
            >
              <span className="text-xl leading-none">{emoji}</span>
              <span className="leading-snug text-card-foreground">{text}</span>
            </button>
          ))}
        </div>
      </div>

      <style>{`
        @keyframes welcomeFadeIn {
          from { opacity: 0; transform: translateY(8px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
}
